// extracted by mini-css-extract-plugin
export default {"span2Rows":"i9QU4CUCpxYbPyX02v7w","span2":"I8qYEZXlYRYlYD0ifRIQ"};